import { createFileRoute } from '@tanstack/react-router'

import { AccountLink } from '@/pages/withdrawal-smz-account-link'

export const Route = createFileRoute('/_protected/withdrawal-smz/account-link/')({
    component: AccountLink,
})
